var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBecomeMemberInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4182 12.4182 16 8 16C3.58172 16 0 12.4182 0 8C0 3.58172 3.58172 0 8 0C12.4182 0 16 3.58172 16 8Z",
    fill: "#FF6B35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00039 12.6016C8.33175 12.6016 8.60039 12.3329 8.60039 12.0016V7.20156C8.60039 6.8702 8.33175 6.60156 8.00039 6.60156C7.66903 6.60156 7.40039 6.8702 7.40039 7.20156V12.0016C7.40039 12.3329 7.66903 12.6016 8.00039 12.6016Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00117 4C8.44301 4 8.80117 4.35817 8.80117 4.8C8.80117 5.24183 8.44301 5.6 8.00117 5.6C7.55933 5.6 7.20117 5.24183 7.20117 4.8C7.20117 4.35817 7.55933 4 8.00117 4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecomeMemberInfoIcon);
export default __webpack_public_path__ + "static/media/become-member-info-icon.e5ce37ce32ae2bbebc606bdc6a91a696.svg";
export { ForwardRef as ReactComponent };